<script lang="ts">
  import { onMount } from "svelte";

  let width;
  let height;
  let left;
  let top;

  window.onresize = () => resize();
  onMount(() => {
    resize();
  });

  function resize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const r = w / h;
    const isportrait = r < 16 / 9;

    if (isportrait) {
      height = h + 160;
      width = (height * 16) / 9;
    } else {
      width = w;
      height = (w * 9) / 16;
    }

    if (width > w) {
      left = (w - width) / 2;
    } else left = 0;
    if (height > h) {
      top = (h - height) / 2;
    }

    document.getElementById("player").style.width = width + "px";
    document.getElementById("player").style.height = height + "px";
    document.getElementById("player").style.top = top + "px";
    document.getElementById("player").style.left = left + "px";
  }
</script>

<svelte:head>
  <script>
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    //플레이어 변수 설정
    var player;

    function onYouTubeIframeAPIReady() {
      player = new YT.Player("player", {
        //width&height를 설정할 수 있으나, 따로 css영역으로 뺐다.
        videoId: "hlGDp8Iudm4",
        playerVars: {
          autoplay: "1",
          disablekb: "1",
          controls: "0",
          showinfo: "0",
          rel: "0",
          fs: "0",
          loop: "1",
          mute: "1",
        },
        events: {
          onReady: onPlayerReady, //로딩중에 이벤트 실행한다
          onStateChange: onPlayerStateChange, //플레이어 상태 변화 시 이벤트를 실행한다.
        },
      });
    }

    function onPlayerReady(event) {
      player.playVideo();
      //로딩된 후에 실행될 동작을 작성한다(소리 크기,동영상 속도를 미리 지정하는 것등등...)
      player.mute();
      player.setLoop(true);
    }

    function onPlayerStateChange(event) {
      if (event.data == 0) {
        player.seekTo(0);
      }
    }
  </script>
</svelte:head>

<div id="movie-bg">
  <div
    id="player"
    style:position={"absolute"}
    style="top: -80px; overflow:hidden;"
  />
  <div id="movie-shield">&nbsp;</div>
  <div class="slot">
    <slot />
  </div>
</div>

<style lang="scss">
  #player {
    width: 100%;
    height: 100%;
  }
  #movie-bg {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 1;

    #movie-shield {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100vh;
      z-index: 2;
      overflow: hidden;
    }

    .slot {
      width: 100%;
      height: 100%;
      z-index: 4;
    }
  }
</style>
